import { SettingsManager } from "@viamap/viamap2-common";

export function getAnnotationIndexName(organizationId?: string): string {
   const baseIndexName = SettingsManager.getSystemSetting("ann.projectsElasticIndexPrefix", undefined, true);
   if (!baseIndexName) {
      throw new Error("Elasticsearch index name not configured. Please set 'ann.projectsElasticIndex' in system settings.");
   }
   return organizationId ? `${baseIndexName}-${organizationId}` : baseIndexName;
}

export function getAnnotationWildcardIndexName(): string {
   return `${getAnnotationIndexName()}*`;
}

export function organizationIdFromAnnotationIndex(indexName?: string): string | undefined {
   if (!indexName) {
      return undefined;
   }
   const prefix = getAnnotationIndexName();
   if (indexName === prefix) {
      return undefined;
   }
   const dashPrefix = `${prefix}-`;
   if (indexName.startsWith(dashPrefix)) {
      return indexName.slice(dashPrefix.length) || undefined;
   }
   return undefined;
}
